import React from "react"

const Card = ({property}) => {
    const {index, picture, alt, link, code, title} = property;
    return (
        <article id={`card-${index}`}>
            <h3>{title}</h3>
            <a href={link} rel="noopener noreferrer" target="_blank" className="project-img"><div><img src={picture} alt={alt}/></div></a>
            <a href={code} rel="noopener noreferrer" target="_blank" className="code-btn">View Code</a>
        </article>
    )
}

export default Card;